module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Thin-7436c0ca711f5b24651caface0f82ef7.woff";